import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { useSearchParamsObject } from 'app/hooks';
// import { useRemoveLoginMutation } from 'services/exploreApi';
import Text from 'common/components/Text/Text';

import styles from './AppNavbar.module.scss';
import { SchoolIcon, ProgramIcon, Logo, Menu, X } from 'assets/landing/index';
import Loader from 'common/components/Loader/Loader';
import { Program, School } from 'app/types';
import { useGetProgramsQuery, useGetSchoolsQuery } from 'services/exploreApi';
import { detailUrl } from 'common/utils/conversions';
import defaultIcon from 'assets/explore/icon-default.svg';
import { useMediaQuery } from 'react-responsive';
import SearchMenu from './SearchMenu';

interface CompProps {
  setIsSearchCollapsed: (collapsed: boolean) => void;
  isSearchCollapsed: boolean;
  isLanding: boolean;
}
interface Pagination {
  pages: number;
  current: number;
  total: number;
}

const defaultPage: Pagination = {
  pages: 0,
  current: 0,
  total: 0,
};

const SearchMenuMobile = ({
  isLanding,
  setIsSearchCollapsed,
  isSearchCollapsed,
}: CompProps): React.ReactElement => {
  const navigate = useNavigate();
  const navigateTo = (route: string) => {
    navigate(route);
    setIsSearchCollapsed(!isSearchCollapsed);
  };
  return (
    <div className={`container-fluid ${isLanding ? styles.landingBG : ''}`}>
      {!isLanding && (
        <div className={`d-flex flex-row justify-content-between ${styles.navContainer}`}>
          <button
            className={`navbar-toggler ${styles.menuLogo}`}
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded={!isSearchCollapsed ? true : false}
            aria-label="Toggle navigation"
            onClick={() => setIsSearchCollapsed(!isSearchCollapsed)}
          ></button>
        </div>
      )}
      <SearchMenu navigateTo={navigateTo} />
    </div>
  );
};

export default SearchMenuMobile;
